// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.signup-username-panel__container {
    display: grid;
    grid-template-columns: repeat(12, 1fr);
    grid-template-rows: auto;
    gap: var( --grid-gap );
    grid-template-areas: "left left left left right right right right right right right right";
    height: 125vh;
    background-color: var( --white-color );
}

.signup-username-panel__container__left-col {
    grid-area: left;
    background-color: var( --primary-very-dark-color );
    height: 125vh;
}

.signup-username-panel__container__right-col {
    grid-column: 8 / 11;
    margin-top: calc( var( --space-x3 ) + var( --space-and-half) - 2px);
}

.signup-username-panel__container__title {
    display: flex;
    align-items: center;
    justify-content: space-between;   
}

.signup-username-panel__container__title span {
    font-size: calc( var( --space-and-half ) + 1px );
    cursor: pointer;    
}

.signup-username-panel__container__upload-img__img {
    width: calc( var( --space-x3 ) + var( --space-x3 ) + var( --space-and-half ) + var( --space-quarter ) );
    height: calc( var( --space-x3 ) + var( --space-x3 ) + var( --space-and-half ) + var( --space-quarter ) );
    border-radius: 50%;
    background: var(--new-input-background-color);
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: var( --space-half );
    margin-bottom: var(--space); 
}

.signup-username-panel__container__upload-img {
    margin-top: var( --space-x3 );
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.signup-username-panel__container__upload-img__img img {
    width: 100%;
    border-radius: 50%;   
} 

.signup-username-panel__container__upload-img__img span {
    font-size: 28px;
    color: var( --primary-dark-color );   
}

.signup-username-panel__label {
    font-family: Roboto; /* TODO change to var */
    font-style: normal;
    font-weight: 500; /* TODO change to var */
    font-size: calc( var( --space ) + 3px );
    line-height: calc( var( --space-and-half ) - 2px );
    display: flex;
    align-items: center;
    letter-spacing: 0.0025em;
    color: var( --primary-dark-color );
    justify-content: center;
}

.signup-username-panel__form__field .input-field-input {
    
    background: var(--new-input-background-color);
    border-radius: calc( var( --space-half ) + 1px );
}

.signup-username-panel__form__field {
    margin: var( --space-half ) 0 var( --space-and-half) 0;
}

.signup-username-panel__form__tip {
    font-family: Roboto; /* TODO change to var */
    font-style: normal;
    font-weight: 500; /* TODO change to var */
    font-size: calc( var( --space ) + 1px );
    line-height: calc( var( --space ) + var( --space-quarter ) );
    text-align: center
}

.signup-username-panel__form__tip:first-of-type {
    color: #30B36B; /* TODO change to var */
}

.signup-username-panel__form__submit {
    margin: 0 auto;
    margin-top: calc( var(--space-x3 ) + var( --space-half ));
    background: #30B36B; /* TODO change to var */
    border-radius: calc( var( --space-quarter ) + 2px );
}

.signup-username-panel__form__submit span {
    font-family: Roboto; /* TODO change to var */
    font-style: normal; 
    font-weight: 500; /* TODO change to var */
    font-size: calc( var( --space ) + 3px );
    line-height: calc( var( --space-and-half ) - 2px );
    letter-spacing: 0.0025em;
    color: var( --white-color );
    text-transform: capitalize;
}

.signup-username-panel__container__upload-img__upload-btn {
    /* TODO primary button */
    background: var( --white-color );
    border: 2px solid #30B36B;
    box-sizing: border-box;
    border-radius: 6px;
    color: #30B36B;
    margin-bottom: var( --space-x3 );
    font-family: Roboto;
    font-style: normal;
    font-weight: 500;
    font-size: 15px;
    line-height: 18px;
}

.signup-username-panel__container__upload-img__upload-btn.button {
    grid-column-gap: 0;
    width: 100%;
    display: block;
    box-shadow: none;
}

.signup-username-panel__title {
    
    /* TODO New_Headline 1 */
    font-family: Barlow;
    font-style: normal;
    font-weight: 600;
    font-size: 30px;
    line-height: 36px;
    /* identical to box height */

    display: flex;
    align-items: center;
    letter-spacing: 0.0025em;

    /* drak gray */

    color: var( --primary-very-dark-color );
}

.signup-username-panel__container__upload-img__img .icon-ball {
    color: var( --white-color );
    font-size: calc( var( --space-x3 ) + var( --space-x3 ) + var( --space-quarter ) + 2px );
    background: var( --primary-color );
    border-radius: 50%;
    padding: calc( var( --space-half ) + 2px );
}`, "",{"version":3,"sources":["webpack://./src/app/authentication/components/signup-username-panel/SignupUserNamePanelComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sCAAsC;IACtC,wBAAwB;IACxB,sBAAsB;IACtB,0FAA0F;IAC1F,aAAa;IACb,sCAAsC;AAC1C;;AAEA;IACI,eAAe;IACf,kDAAkD;IAClD,aAAa;AACjB;;AAEA;IACI,mBAAmB;IACnB,mEAAmE;AACvE;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,gDAAgD;IAChD,eAAe;AACnB;;AAEA;IACI,uGAAuG;IACvG,wGAAwG;IACxG,kBAAkB;IAClB,6CAA6C;IAC7C,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,+BAA+B;IAC/B,2BAA2B;AAC/B;;AAEA;IACI,6BAA6B;IAC7B,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,kCAAkC;AACtC;;AAEA;IACI,mBAAmB,EAAE,uBAAuB;IAC5C,kBAAkB;IAClB,gBAAgB,EAAE,uBAAuB;IACzC,uCAAuC;IACvC,kDAAkD;IAClD,aAAa;IACb,mBAAmB;IACnB,wBAAwB;IACxB,kCAAkC;IAClC,uBAAuB;AAC3B;;AAEA;;IAEI,6CAA6C;IAC7C,gDAAgD;AACpD;;AAEA;IACI,sDAAsD;AAC1D;;AAEA;IACI,mBAAmB,EAAE,uBAAuB;IAC5C,kBAAkB;IAClB,gBAAgB,EAAE,uBAAuB;IACzC,uCAAuC;IACvC,4DAA4D;IAC5D;AACJ;;AAEA;IACI,cAAc,EAAE,uBAAuB;AAC3C;;AAEA;IACI,cAAc;IACd,yDAAyD;IACzD,mBAAmB,EAAE,uBAAuB;IAC5C,mDAAmD;AACvD;;AAEA;IACI,mBAAmB,EAAE,uBAAuB;IAC5C,kBAAkB;IAClB,gBAAgB,EAAE,uBAAuB;IACzC,uCAAuC;IACvC,kDAAkD;IAClD,wBAAwB;IACxB,2BAA2B;IAC3B,0BAA0B;AAC9B;;AAEA;IACI,wBAAwB;IACxB,gCAAgC;IAChC,yBAAyB;IACzB,sBAAsB;IACtB,kBAAkB;IAClB,cAAc;IACd,gCAAgC;IAChC,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,cAAc;IACd,gBAAgB;AACpB;;AAEA;;IAEI,wBAAwB;IACxB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,4BAA4B;;IAE5B,aAAa;IACb,mBAAmB;IACnB,wBAAwB;;IAExB,cAAc;;IAEd,uCAAuC;AAC3C;;AAEA;IACI,2BAA2B;IAC3B,uFAAuF;IACvF,kCAAkC;IAClC,kBAAkB;IAClB,0CAA0C;AAC9C","sourcesContent":[".signup-username-panel__container {\n    display: grid;\n    grid-template-columns: repeat(12, 1fr);\n    grid-template-rows: auto;\n    gap: var( --grid-gap );\n    grid-template-areas: \"left left left left right right right right right right right right\";\n    height: 125vh;\n    background-color: var( --white-color );\n}\n\n.signup-username-panel__container__left-col {\n    grid-area: left;\n    background-color: var( --primary-very-dark-color );\n    height: 125vh;\n}\n\n.signup-username-panel__container__right-col {\n    grid-column: 8 / 11;\n    margin-top: calc( var( --space-x3 ) + var( --space-and-half) - 2px);\n}\n\n.signup-username-panel__container__title {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;   \n}\n\n.signup-username-panel__container__title span {\n    font-size: calc( var( --space-and-half ) + 1px );\n    cursor: pointer;    \n}\n\n.signup-username-panel__container__upload-img__img {\n    width: calc( var( --space-x3 ) + var( --space-x3 ) + var( --space-and-half ) + var( --space-quarter ) );\n    height: calc( var( --space-x3 ) + var( --space-x3 ) + var( --space-and-half ) + var( --space-quarter ) );\n    border-radius: 50%;\n    background: var(--new-input-background-color);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-top: var( --space-half );\n    margin-bottom: var(--space); \n}\n\n.signup-username-panel__container__upload-img {\n    margin-top: var( --space-x3 );\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n}\n\n.signup-username-panel__container__upload-img__img img {\n    width: 100%;\n    border-radius: 50%;   \n} \n\n.signup-username-panel__container__upload-img__img span {\n    font-size: 28px;\n    color: var( --primary-dark-color );   \n}\n\n.signup-username-panel__label {\n    font-family: Roboto; /* TODO change to var */\n    font-style: normal;\n    font-weight: 500; /* TODO change to var */\n    font-size: calc( var( --space ) + 3px );\n    line-height: calc( var( --space-and-half ) - 2px );\n    display: flex;\n    align-items: center;\n    letter-spacing: 0.0025em;\n    color: var( --primary-dark-color );\n    justify-content: center;\n}\n\n.signup-username-panel__form__field .input-field-input {\n    \n    background: var(--new-input-background-color);\n    border-radius: calc( var( --space-half ) + 1px );\n}\n\n.signup-username-panel__form__field {\n    margin: var( --space-half ) 0 var( --space-and-half) 0;\n}\n\n.signup-username-panel__form__tip {\n    font-family: Roboto; /* TODO change to var */\n    font-style: normal;\n    font-weight: 500; /* TODO change to var */\n    font-size: calc( var( --space ) + 1px );\n    line-height: calc( var( --space ) + var( --space-quarter ) );\n    text-align: center\n}\n\n.signup-username-panel__form__tip:first-of-type {\n    color: #30B36B; /* TODO change to var */\n}\n\n.signup-username-panel__form__submit {\n    margin: 0 auto;\n    margin-top: calc( var(--space-x3 ) + var( --space-half ));\n    background: #30B36B; /* TODO change to var */\n    border-radius: calc( var( --space-quarter ) + 2px );\n}\n\n.signup-username-panel__form__submit span {\n    font-family: Roboto; /* TODO change to var */\n    font-style: normal; \n    font-weight: 500; /* TODO change to var */\n    font-size: calc( var( --space ) + 3px );\n    line-height: calc( var( --space-and-half ) - 2px );\n    letter-spacing: 0.0025em;\n    color: var( --white-color );\n    text-transform: capitalize;\n}\n\n.signup-username-panel__container__upload-img__upload-btn {\n    /* TODO primary button */\n    background: var( --white-color );\n    border: 2px solid #30B36B;\n    box-sizing: border-box;\n    border-radius: 6px;\n    color: #30B36B;\n    margin-bottom: var( --space-x3 );\n    font-family: Roboto;\n    font-style: normal;\n    font-weight: 500;\n    font-size: 15px;\n    line-height: 18px;\n}\n\n.signup-username-panel__container__upload-img__upload-btn.button {\n    grid-column-gap: 0;\n    width: 100%;\n    display: block;\n    box-shadow: none;\n}\n\n.signup-username-panel__title {\n    \n    /* TODO New_Headline 1 */\n    font-family: Barlow;\n    font-style: normal;\n    font-weight: 600;\n    font-size: 30px;\n    line-height: 36px;\n    /* identical to box height */\n\n    display: flex;\n    align-items: center;\n    letter-spacing: 0.0025em;\n\n    /* drak gray */\n\n    color: var( --primary-very-dark-color );\n}\n\n.signup-username-panel__container__upload-img__img .icon-ball {\n    color: var( --white-color );\n    font-size: calc( var( --space-x3 ) + var( --space-x3 ) + var( --space-quarter ) + 2px );\n    background: var( --primary-color );\n    border-radius: 50%;\n    padding: calc( var( --space-half ) + 2px );\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
